import { onMounted, onUnmounted } from 'vue'

interface EventRegister {
  keyboardKey: string,
  keyboardModifier?: string,
  action: () => void,
}

export function useKeyboardEvent (data: EventRegister[]) {
  const keyboardListener = (event: KeyboardEvent) => {
    data.forEach((item) => {
      if (event.key === item.keyboardKey && item.keyboardModifier && event.getModifierState(item.keyboardModifier)) {
        item.action()
      } else if (event.key === item.keyboardKey && !item.keyboardModifier) {
        item.action()
      }
    })
  }

  onMounted(() => {
    document.addEventListener('keydown', keyboardListener)
  })

  onUnmounted(() => {
    document.removeEventListener('keydown', keyboardListener)
  })
}
